import {Component, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: "app-logout",
    templateUrl: "./logout.component.html",
    styleUrls: ["./logout.component.scss"],
    standalone: false
})
export class LogoutComponent implements OnInit {

	constructor(private translate: TranslateService) {
		translate.use(translate.getBrowserLang() || 'en');
	}

	ngOnInit() {
	}

	deleteAllCookies() {
	}
}
